// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"92":"ed8d753d","166":"3e774ed6","182":"43c6f22b","279":"2d946961","516":"dfe9642a","740":"ed8d753d","966":"ed8d753d"}[chunkId] + ".chunk.css";
};